import DrawerHeader from "ds/components/Drawer/Header";
import DrawerBody from "ds/components/Drawer/Body";
import Typography from "ds/components/Typography";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";

import styles from "./styles.module.css";

const RoleInfoDrawerContent = () => {
  return (
    <>
      <DrawerHeader justify="between">
        <DrawerHeaderTitle title="Permissions" />
        <DrawerCloseIcon />
      </DrawerHeader>
      <DrawerBody fullHeight>
        <Typography tag="p" variant="p-body2" className={styles.description}>
          Each entity in Spacelift supports a specific set of actions. These actions are represented
          as permissions, which can be combined to create custom roles for managing access.
        </Typography>
        {/* TODO: [AAC] add documentation for permissions */}
        {/* <DrawerFooter>
          <DocumentationButton
            to={getDocsUrl("/concepts/user-management/admin#users")}
            analyticsPage={AnalyticsPageOrganization.OrganizationUsers}
          />
        </DrawerFooter> */}
      </DrawerBody>
    </>
  );
};

export default RoleInfoDrawerContent;
